import HighlightBanner from './highlight-banner.js';

export default HighlightBanner;
